
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.5.0
 * Query Engine version: 173f8d54f8d52e692c7e27e72a88314ec7aeff60
 */
Prisma.prismaVersion = {
  client: "6.5.0",
  engine: "173f8d54f8d52e692c7e27e72a88314ec7aeff60"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  activeFacilityId: 'activeFacilityId',
  activePracticeId: 'activePracticeId'
};

exports.Prisma.TextTemplateScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  dataModel: 'dataModel',
  dataField: 'dataField',
  template: 'template',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MessageThreadScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  practiceId: 'practiceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MessageScalarFieldEnum = {
  id: 'id',
  messageThreadId: 'messageThreadId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  body: 'body',
  userName: 'userName'
};

exports.Prisma.AddressScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StorageBlobScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId',
  userId: 'userId',
  key: 'key',
  filename: 'filename',
  contentType: 'contentType',
  byteSize: 'byteSize',
  checksum: 'checksum'
};

exports.Prisma.BucketScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId',
  name: 'name'
};

exports.Prisma.InternalMigrationScalarFieldEnum = {
  id: 'id',
  startedAt: 'startedAt',
  finishedAt: 'finishedAt',
  name: 'name',
  checksum: 'checksum'
};

exports.Prisma.BulkCreateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  organizationId: 'organizationId',
  source: 'source',
  destination: 'destination',
  name: 'name',
  path: 'path'
};

exports.Prisma.StaffScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  organizationId: 'organizationId',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  firstName: 'firstName',
  middleName: 'middleName',
  lastName: 'lastName',
  qualification: 'qualification',
  email: 'email',
  mobilePhone: 'mobilePhone',
  officePhone: 'officePhone',
  providerSpecialtyId: 'providerSpecialtyId',
  npi: 'npi',
  taxonomyCode: 'taxonomyCode',
  stateLicenseNumber: 'stateLicenseNumber',
  upin: 'upin'
};

exports.Prisma.FacilityHoursScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  day: 'day',
  open: 'open',
  openTime: 'openTime',
  closeTime: 'closeTime'
};

exports.Prisma.RoleScalarFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.TimePeriodScalarFieldEnum = {
  id: 'id',
  roomId: 'roomId',
  practiceId: 'practiceId',
  surgeonId: 'surgeonId',
  startTime: 'startTime',
  endTime: 'endTime',
  type: 'type',
  color: 'color',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  recurrenceId: 'recurrenceId',
  name: 'name',
  flipRoomId: 'flipRoomId',
  isFlip: 'isFlip'
};

exports.Prisma.TimePeriodScheduleScalarFieldEnum = {
  id: 'id',
  startDate: 'startDate',
  endDate: 'endDate',
  interval: 'interval',
  unit: 'unit',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  weekOfMonth: 'weekOfMonth',
  dayOfWeek: 'dayOfWeek',
  recurrenceMethod: 'recurrenceMethod'
};

exports.Prisma.PreferenceCardScalarFieldEnum = {
  id: 'id',
  title: 'title',
  providerId: 'providerId',
  positioning: 'positioning',
  prep: 'prep',
  drapes: 'drapes',
  notes: 'notes',
  gloves: 'gloves',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId',
  deepUpdatedAt: 'deepUpdatedAt'
};

exports.Prisma.EquipmentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  type: 'type',
  active: 'active',
  inventoryNumber: 'inventoryNumber',
  supplierNumber: 'supplierNumber',
  supplierId: 'supplierId',
  supplierRepId: 'supplierRepId',
  organizationId: 'organizationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PreferenceCardEquipmentScalarFieldEnum = {
  id: 'id',
  preferenceCardId: 'preferenceCardId',
  equipmentId: 'equipmentId',
  open: 'open',
  hold: 'hold',
  comments: 'comments'
};

exports.Prisma.CasePreferenceCardScalarFieldEnum = {
  id: 'id',
  caseId: 'caseId',
  preferenceCardId: 'preferenceCardId',
  quantity: 'quantity',
  version: 'version',
  positioning: 'positioning',
  prep: 'prep',
  drapes: 'drapes',
  notes: 'notes',
  gloves: 'gloves',
  copiedAt: 'copiedAt'
};

exports.Prisma.CasePreferenceCardEquipmentScalarFieldEnum = {
  id: 'id',
  casePreferenceCardId: 'casePreferenceCardId',
  preferenceCardEquipmentId: 'preferenceCardEquipmentId',
  used: 'used',
  open: 'open',
  hold: 'hold',
  comments: 'comments',
  equipmentId: 'equipmentId',
  equipmentVersion: 'equipmentVersion'
};

exports.Prisma.SpecialtyScalarFieldEnum = {
  id: 'id',
  name: 'name',
  color: 'color',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SupplierScalarFieldEnum = {
  id: 'id',
  name: 'name',
  portalUrl: 'portalUrl',
  relationship: 'relationship',
  active: 'active',
  organizationId: 'organizationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SupplierRepScalarFieldEnum = {
  id: 'id',
  name: 'name',
  supplierId: 'supplierId',
  officePhone: 'officePhone',
  mobilePhone: 'mobilePhone',
  email: 'email',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EquipmentRequirementScalarFieldEnum = {
  id: 'id',
  caseId: 'caseId',
  equipmentId: 'equipmentId',
  quantity: 'quantity',
  status: 'status',
  representativeStatus: 'representativeStatus',
  requiredAtOperation: 'requiredAtOperation'
};

exports.Prisma.ProcedureScalarFieldEnum = {
  id: 'id',
  cptCodeId: 'cptCodeId',
  caseId: 'caseId',
  description: 'description',
  laterality: 'laterality',
  possible: 'possible',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AttachmentTypeScalarFieldEnum = {
  id: 'id',
  name: 'name',
  label: 'label',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AttachmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  attachmentTypeId: 'attachmentTypeId',
  caseId: 'caseId',
  storageBlobId: 'storageBlobId',
  name: 'name'
};

exports.Prisma.InsuranceProviderScalarFieldEnum = {
  id: 'id',
  name: 'name',
  organizationId: 'organizationId',
  active: 'active',
  waystarInsuranceProviderId: 'waystarInsuranceProviderId',
  electronicPaymentFormat: 'electronicPaymentFormat',
  claimAddressId: 'claimAddressId',
  claimPhoneNumber: 'claimPhoneNumber',
  claimFaxNumber: 'claimFaxNumber',
  isMedicare: 'isMedicare'
};

exports.Prisma.WorkersCompProviderScalarFieldEnum = {
  id: 'id',
  name: 'name',
  organizationId: 'organizationId',
  active: 'active',
  waystarProviderId: 'waystarProviderId',
  electronicPaymentFormat: 'electronicPaymentFormat',
  claimAddressId: 'claimAddressId',
  claimPhoneNumber: 'claimPhoneNumber',
  claimFaxNumber: 'claimFaxNumber'
};

exports.Prisma.WaystarInsuranceProviderScalarFieldEnum = {
  id: 'id',
  name: 'name',
  externalId: 'externalId',
  professionalClaimsAvailable: 'professionalClaimsAvailable',
  professionalClaimsNeedsEnrollment: 'professionalClaimsNeedsEnrollment',
  institutionalClaimsAvailable: 'institutionalClaimsAvailable',
  institutionalClaimsNeedsEnrollment: 'institutionalClaimsNeedsEnrollment',
  remitsAvailable: 'remitsAvailable',
  remitsNeedsEnrollment: 'remitsNeedsEnrollment',
  eligibilityAvailable: 'eligibilityAvailable',
  eligibilityNeedsEnrollment: 'eligibilityNeedsEnrollment',
  claimsMonitoringAvailable: 'claimsMonitoringAvailable',
  claimsMonitoringNeedsEnrollment: 'claimsMonitoringNeedsEnrollment',
  secondaryClaimFormat: 'secondaryClaimFormat',
  dualClearinghouseFlags: 'dualClearinghouseFlags',
  claimsAttachments: 'claimsAttachments',
  estimationAvailable: 'estimationAvailable',
  estimationNeedsEnrollment: 'estimationNeedsEnrollment',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  waystarProviderGroupId: 'waystarProviderGroupId'
};

exports.Prisma.WaystarPayerGroupScalarFieldEnum = {
  id: 'id',
  canonicalName: 'canonicalName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentInsuranceAttachmentTypeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  label: 'label'
};

exports.Prisma.PaymentInsuranceAttachmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  paymentInsuranceAttachmentTypeId: 'paymentInsuranceAttachmentTypeId',
  paymentInsuranceId: 'paymentInsuranceId',
  storageBlobId: 'storageBlobId',
  name: 'name'
};

exports.Prisma.PaymentWorkersCompAttachmentTypeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  label: 'label'
};

exports.Prisma.PaymentWorkersCompAttachmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  paymentWorkersCompAttachmentTypeId: 'paymentWorkersCompAttachmentTypeId',
  paymentWorkersCompId: 'paymentWorkersCompId',
  storageBlobId: 'storageBlobId',
  name: 'name'
};

exports.Prisma.PaymentInsuranceScalarFieldEnum = {
  id: 'id',
  caseId: 'caseId',
  name: 'name',
  member: 'member',
  firstName: 'firstName',
  lastName: 'lastName',
  middleName: 'middleName',
  relationship: 'relationship',
  policyNumber: 'policyNumber',
  groupNumber: 'groupNumber',
  primary: 'primary',
  preAuthStatus: 'preAuthStatus',
  preAuthValidated: 'preAuthValidated',
  preAuthRequired: 'preAuthRequired',
  authorizationNumber: 'authorizationNumber',
  insuranceRepName: 'insuranceRepName',
  insuranceRepPhone: 'insuranceRepPhone',
  insuranceRepEmail: 'insuranceRepEmail',
  preCertNumber: 'preCertNumber',
  preCertDate: 'preCertDate',
  preCertValidStart: 'preCertValidStart',
  preCertValidEnd: 'preCertValidEnd',
  deductibleInDollars: 'deductibleInDollars',
  deductibleMetInDollars: 'deductibleMetInDollars',
  deductibleRemaining: 'deductibleRemaining',
  outOfPocketInDollars: 'outOfPocketInDollars',
  outOfPocketMetInDollars: 'outOfPocketMetInDollars',
  outOfPocketRemaining: 'outOfPocketRemaining',
  coinsurancePercentage: 'coinsurancePercentage',
  facilityFeeInDollars: 'facilityFeeInDollars',
  anesthesiaFeeInDollars: 'anesthesiaFeeInDollars',
  coPayInDollars: 'coPayInDollars',
  notes: 'notes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  patientNoteId: 'patientNoteId',
  insuranceVerified: 'insuranceVerified',
  insuranceVerifiedAt: 'insuranceVerifiedAt',
  stediVerificationCount: 'stediVerificationCount',
  networkContract: 'networkContract',
  providerId: 'providerId',
  otherInsurerName: 'otherInsurerName',
  isInsuranceUnlisted: 'isInsuranceUnlisted'
};

exports.Prisma.PaymentWorkersCompScalarFieldEnum = {
  id: 'id',
  caseId: 'caseId',
  carrier: 'carrier',
  claimNumber: 'claimNumber',
  address: 'address',
  authorizationNumber: 'authorizationNumber',
  adjustor: 'adjustor',
  adjustorPhone: 'adjustorPhone',
  dateOfInjury: 'dateOfInjury',
  notes: 'notes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  providerId: 'providerId'
};

exports.Prisma.PaymentSelfPayScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  caseId: 'caseId',
  paymentMethodTypeId: 'paymentMethodTypeId',
  practiceCollectsAllPayment: 'practiceCollectsAllPayment',
  practiceCollectsProviderPayment: 'practiceCollectsProviderPayment',
  notes: 'notes'
};

exports.Prisma.PaymentLetterProtectionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  caseId: 'caseId',
  accidentDate: 'accidentDate',
  adjuster: 'adjuster',
  attorney: 'attorney',
  attorneyPhone: 'attorneyPhone',
  carInsurance: 'carInsurance',
  carInsurancePolicyNumber: 'carInsurancePolicyNumber',
  claimNumber: 'claimNumber',
  location: 'location',
  surgeryAuthorization: 'surgeryAuthorization',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  state: 'state',
  zip: 'zip'
};

exports.Prisma.PaymentMethodTypeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  label: 'label'
};

exports.Prisma.JobRoleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  type: 'type'
};

exports.Prisma.OrganizationRelationshipScalarFieldEnum = {
  id: 'id',
  facilityOrgId: 'facilityOrgId',
  practiceOrgId: 'practiceOrgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CaseRoleScalarFieldEnum = {
  id: 'id',
  caseId: 'caseId',
  staffId: 'staffId',
  jobRoleId: 'jobRoleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  roleId: 'roleId'
};

exports.Prisma.TagScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  type: 'type',
  name: 'name',
  abbreviation: 'abbreviation',
  color: 'color'
};

exports.Prisma.HealthReviewTypeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  label: 'label'
};

exports.Prisma.HealthReviewConditionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  healthReviewTypeId: 'healthReviewTypeId',
  organizationId: 'organizationId',
  isRequired: 'isRequired',
  isRequiredOver50: 'isRequiredOver50'
};

exports.Prisma.HealthReviewRequirementScalarFieldEnum = {
  id: 'id',
  caseId: 'caseId',
  healthReviewTypeId: 'healthReviewTypeId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  reviewedAt: 'reviewedAt',
  providerName: 'providerName',
  providerPhone: 'providerPhone'
};

exports.Prisma.HealthReviewRequirementAttachmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  healthReviewRequirementId: 'healthReviewRequirementId',
  storageBlobId: 'storageBlobId',
  name: 'name'
};

exports.Prisma.MedicalConditionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  abbreviation: 'abbreviation',
  color: 'color'
};

exports.Prisma.CaseMedicalConditionScalarFieldEnum = {
  id: 'id',
  caseId: 'caseId',
  medicalConditionId: 'medicalConditionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CaseStatusTrackerScalarFieldEnum = {
  id: 'id',
  caseId: 'caseId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hasEquipment: 'hasEquipment',
  hasHealthReview: 'hasHealthReview',
  hasInsurance: 'hasInsurance',
  hasPreAdmitQuestionnaire: 'hasPreAdmitQuestionnaire',
  hasSchedulingConflict: 'hasSchedulingConflict',
  healthReviewMissingApprovals: 'healthReviewMissingApprovals',
  healthReviewMissingRequirements: 'healthReviewMissingRequirements',
  healthReviewRequirementsStatus: 'healthReviewRequirementsStatus',
  healthReviewStatus: 'healthReviewStatus',
  insurancePreAuthorizationStatus: 'insurancePreAuthorizationStatus',
  insuranceVerificationFlag: 'insuranceVerificationFlag',
  overviewClearanceFlag: 'overviewClearanceFlag',
  overviewEquipmentFlag: 'overviewEquipmentFlag',
  overviewHealthReviewFlag: 'overviewHealthReviewFlag',
  overviewHistoryPhysicalFlag: 'overviewHistoryPhysicalFlag',
  overviewInsuranceFlag: 'overviewInsuranceFlag',
  overviewPatFlag: 'overviewPatFlag',
  overviewTestingFlag: 'overviewTestingFlag',
  isMissingEquipment: 'isMissingEquipment',
  isMissingMedical: 'isMissingMedical',
  isMissingMultiple: 'isMissingMultiple',
  isMissingPayment: 'isMissingPayment'
};

exports.Prisma.BillingPayerScalarFieldEnum = {
  id: 'id',
  sequenceNumber: 'sequenceNumber',
  billingCaseId: 'billingCaseId',
  paymentInsuranceId: 'paymentInsuranceId',
  paymentWorkersCompId: 'paymentWorkersCompId',
  paymentSelfPayId: 'paymentSelfPayId',
  paymentLetterOfProtectionId: 'paymentLetterOfProtectionId',
  paymentType: 'paymentType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  notes: 'notes',
  waystarInsuranceProviderId: 'waystarInsuranceProviderId'
};

exports.Prisma.BillingCaseScalarFieldEnum = {
  id: 'id',
  caseId: 'caseId',
  nextPayerId: 'nextPayerId',
  careTypeCode: 'careTypeCode',
  facilityTypeCode: 'facilityTypeCode',
  dischargeCode: 'dischargeCode',
  occurrenceCode: 'occurrenceCode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  missingOpReportThreadId: 'missingOpReportThreadId'
};

exports.Prisma.BillingDiagnosisScalarFieldEnum = {
  id: 'id',
  billingCaseId: 'billingCaseId',
  icd10Code: 'icd10Code',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sequenceNumber: 'sequenceNumber'
};

exports.Prisma.BillingModifierScalarFieldEnum = {
  id: 'id',
  modifierCode: 'modifierCode',
  name: 'name',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BillingChargeScalarFieldEnum = {
  id: 'id',
  revenueCode: 'revenueCode',
  units: 'units',
  sequenceNumber: 'sequenceNumber',
  billingChargeMasterId: 'billingChargeMasterId',
  unitCost: 'unitCost',
  billingCaseId: 'billingCaseId',
  billedAmount: 'billedAmount',
  currency: 'currency',
  payerTypes: 'payerTypes',
  collectFromOffice: 'collectFromOffice',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BillingChargeModifierScalarFieldEnum = {
  id: 'id',
  billingChargeId: 'billingChargeId',
  billingModifierId: 'billingModifierId',
  sequenceNumber: 'sequenceNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BillingClaimScalarFieldEnum = {
  id: 'id',
  billingPayerId: 'billingPayerId',
  frequencyCode: 'frequencyCode',
  status: 'status',
  billingCaseId: 'billingCaseId',
  referenceNumber: 'referenceNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  firstSubmittedAt: 'firstSubmittedAt',
  lastSubmittedAt: 'lastSubmittedAt',
  submissionCount: 'submissionCount',
  agingThreadId: 'agingThreadId',
  generalThreadId: 'generalThreadId'
};

exports.Prisma.BillingChargeMasterScalarFieldEnum = {
  id: 'id',
  billingOrganizationId: 'billingOrganizationId',
  cptCode: 'cptCode',
  amount: 'amount',
  selfPayAmount: 'selfPayAmount',
  currency: 'currency',
  active: 'active',
  allowAmountOverride: 'allowAmountOverride',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BillingTransactionScalarFieldEnum = {
  id: 'id',
  status: 'status',
  amount: 'amount',
  currency: 'currency',
  checkDate: 'checkDate',
  aba: 'aba',
  payerType: 'payerType',
  payerName: 'payerName',
  transactionDate: 'transactionDate',
  paymentMethod: 'paymentMethod',
  referenceNumber: 'referenceNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId',
  providerId: 'providerId'
};

exports.Prisma.BillingOrganizationScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  staffId: 'staffId',
  stediPartnershipId: 'stediPartnershipId'
};

exports.Prisma.BillingAdjustmentScalarFieldEnum = {
  id: 'id',
  code: 'code',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  reportAs: 'reportAs'
};

exports.Prisma.BillingTransactionAllocationScalarFieldEnum = {
  id: 'id',
  billingTransactionId: 'billingTransactionId',
  billingChargeId: 'billingChargeId',
  billingClaimId: 'billingClaimId',
  amount: 'amount',
  currency: 'currency',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  billingAdjustmentId: 'billingAdjustmentId',
  adjustmentGroup: 'adjustmentGroup',
  status: 'status'
};

exports.Prisma.BillingCaseAttachmentTypeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  label: 'label'
};

exports.Prisma.BillingCaseAttachmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  billingCaseAttachmentTypeId: 'billingCaseAttachmentTypeId',
  billingCaseId: 'billingCaseId',
  storageBlobId: 'storageBlobId',
  name: 'name'
};

exports.Prisma.ConsentFormScalarFieldEnum = {
  id: 'id',
  name: 'name',
  organizationId: 'organizationId',
  formType: 'formType',
  consentType: 'consentType',
  url: 'url',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PatientConsentScalarFieldEnum = {
  id: 'id',
  status: 'status',
  caseId: 'caseId',
  consentFormId: 'consentFormId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  effectiveAt: 'effectiveAt'
};

exports.Prisma.CptCodeScalarFieldEnum = {
  code: 'code',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isActive: 'isActive',
  kind: 'kind',
  name: 'name',
  description: 'description'
};

exports.Prisma.ConditionScalarFieldEnum = {
  name: 'name',
  icd10: 'icd10',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CodeableConceptScalarFieldEnum = {
  id: 'id',
  code: 'code',
  display: 'display',
  description: 'description',
  key: 'key',
  codeableConceptId: 'codeableConceptId',
  activeFrom: 'activeFrom',
  activeTo: 'activeTo'
};

exports.Prisma.PatientScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  homeAddressId: 'homeAddressId',
  organizationId: 'organizationId',
  userId: 'userId',
  preferredName: 'preferredName',
  firstName: 'firstName',
  lastName: 'lastName',
  middleName: 'middleName',
  suffixName: 'suffixName',
  ssn: 'ssn',
  dateOfBirth: 'dateOfBirth',
  sex: 'sex',
  email: 'email',
  primaryPhone: 'primaryPhone',
  secondaryPhone: 'secondaryPhone',
  mrn: 'mrn',
  phantom: 'phantom',
  completion: 'completion'
};

exports.Prisma.DiagnosisScalarFieldEnum = {
  id: 'id',
  conditionId: 'conditionId',
  caseId: 'caseId',
  icd10: 'icd10',
  reporter: 'reporter',
  status: 'status',
  effective: 'effective',
  invalidated: 'invalidated',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AllergyScalarFieldEnum = {
  id: 'id',
  patientId: 'patientId',
  name: 'name',
  notes: 'notes',
  status: 'status',
  effective: 'effective',
  invalidated: 'invalidated',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  severity: 'severity'
};

exports.Prisma.PatientConditionScalarFieldEnum = {
  id: 'id',
  patientId: 'patientId',
  name: 'name',
  present: 'present',
  effective: 'effective',
  notes: 'notes',
  invalidated: 'invalidated',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SurgeryProfileScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  surgeryDescription: 'surgeryDescription',
  surgeonId: 'surgeonId',
  expectedCaseLength: 'expectedCaseLength',
  anesthesiaType: 'anesthesiaType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  emrTemplateId: 'emrTemplateId'
};

exports.Prisma.SurgeryProfileDiagnosisScalarFieldEnum = {
  id: 'id',
  surgeryProfileId: 'surgeryProfileId',
  icd10: 'icd10',
  sequenceNumber: 'sequenceNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SurgeryProfileChargeScalarFieldEnum = {
  id: 'id',
  surgeryProfileId: 'surgeryProfileId',
  cptCode: 'cptCode',
  sequenceNumber: 'sequenceNumber',
  laterality: 'laterality',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ClinicalEventScalarFieldEnum = {
  id: 'id',
  encounterId: 'encounterId',
  eventId: 'eventId',
  resultType: 'resultType',
  resultText: 'resultText',
  resultInt: 'resultInt',
  resultFloat: 'resultFloat',
  resultUnitId: 'resultUnitId',
  marId: 'marId',
  eventStartTime: 'eventStartTime',
  eventEndTime: 'eventEndTime',
  performerId: 'performerId',
  signedById: 'signedById',
  invalidatedById: 'invalidatedById',
  invalidatedAt: 'invalidatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  attachedToLineId: 'attachedToLineId'
};

exports.Prisma.MedicationAdministrationRecordScalarFieldEnum = {
  id: 'id',
  orderId: 'orderId',
  medication: 'medication',
  registrarId: 'registrarId',
  frequency: 'frequency',
  dose: 'dose',
  unitsId: 'unitsId',
  route: 'route',
  site: 'site',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LineScalarFieldEnum = {
  id: 'id',
  clinicalEventId: 'clinicalEventId',
  typeId: 'typeId',
  gauge: 'gauge',
  site: 'site',
  notes: 'notes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ClinicalEventDimensionScalarFieldEnum = {
  id: 'id',
  clinicalEventId: 'clinicalEventId',
  dimensionId: 'dimensionId',
  valueJson: 'valueJson',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ContractModifierWeightScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  contractId: 'contractId',
  modifierId: 'modifierId',
  multiplier: 'multiplier'
};

exports.Prisma.ContractMultipleProcedureReimbursementRateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  contractId: 'contractId',
  thresholdMinimum: 'thresholdMinimum',
  thresholdMaximum: 'thresholdMaximum',
  multiplier: 'multiplier'
};

exports.Prisma.ContractListRuleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  listId: 'listId',
  operation: 'operation',
  manipulator: 'manipulator',
  condition: 'condition',
  comparison: 'comparison'
};

exports.Prisma.ContractListScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  contractId: 'contractId',
  name: 'name'
};

exports.Prisma.ContractListMemberScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  listId: 'listId',
  code: 'code'
};

exports.Prisma.ContractProcedureMetadataScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  contractId: 'contractId',
  procedure: 'procedure',
  flags: 'flags'
};

exports.Prisma.ContractScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId',
  payerId: 'payerId',
  effectiveStart: 'effectiveStart',
  effectiveEnd: 'effectiveEnd',
  payerRateRule: 'payerRateRule'
};

exports.Prisma.DocumentTemplateScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  title: 'title',
  typeId: 'typeId',
  body: 'body',
  preview: 'preview',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  jobRoleTypes: 'jobRoleTypes'
};

exports.Prisma.EmrTemplateScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archived: 'archived'
};

exports.Prisma.EmrTemplatePageScalarFieldEnum = {
  id: 'id',
  workflowType: 'workflowType',
  emrTemplateId: 'emrTemplateId',
  version: 'version',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmrTemplateSectionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  emrTemplatePageId: 'emrTemplatePageId',
  heading: 'heading',
  sequenceNumber: 'sequenceNumber',
  type: 'type',
  config: 'config'
};

exports.Prisma.PublicSubmissionScalarFieldEnum = {
  id: 'id',
  facilityId: 'facilityId',
  type: 'type',
  reviewStatus: 'reviewStatus',
  archived: 'archived',
  migrated: 'migrated',
  encounterId: 'encounterId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  signatureId: 'signatureId'
};

exports.Prisma.EncounterDocumentScalarFieldEnum = {
  id: 'id',
  documentTemplateId: 'documentTemplateId',
  encounterId: 'encounterId',
  title: 'title',
  body: 'body',
  preview: 'preview',
  typeId: 'typeId'
};

exports.Prisma.EncounterScalarFieldEnum = {
  id: 'id',
  appointmentId: 'appointmentId',
  identifier: 'identifier',
  length: 'length',
  lengthId: 'lengthId',
  patientId: 'patientId',
  patientSubmissionStatus: 'patientSubmissionStatus',
  periodStart: 'periodStart',
  periodEnd: 'periodEnd',
  priorityId: 'priorityId',
  serviceProviderId: 'serviceProviderId',
  open: 'open',
  status: 'status',
  emrTemplateId: 'emrTemplateId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  matchedSubmissionId: 'matchedSubmissionId',
  phantom: 'phantom'
};

exports.Prisma.EncounterClosureScalarFieldEnum = {
  id: 'id',
  encounterId: 'encounterId',
  closedAt: 'closedAt',
  closedById: 'closedById',
  chartValid: 'chartValid',
  forceClosed: 'forceClosed',
  isIncomplete: 'isIncomplete',
  hasVariance: 'hasVariance',
  hasIncidents: 'hasIncidents',
  printed: 'printed'
};

exports.Prisma.EncounterWorkflowScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  chargeNurseId: 'chargeNurseId',
  emrTemplatePageId: 'emrTemplatePageId',
  encounterId: 'encounterId',
  patStatus: 'patStatus'
};

exports.Prisma.EncounterWorkflowSignatureScalarFieldEnum = {
  id: 'id',
  encounterWorkflowId: 'encounterWorkflowId',
  state: 'state',
  signedAt: 'signedAt',
  signedById: 'signedById',
  signedName: 'signedName'
};

exports.Prisma.CaseScalarFieldEnum = {
  id: 'id',
  financialReference: 'financialReference',
  requestedById: 'requestedById',
  createdBy: 'createdBy',
  status: 'status',
  cancellationReason: 'cancellationReason',
  surgeryDate: 'surgeryDate',
  roomId: 'roomId',
  facilityId: 'facilityId',
  practiceId: 'practiceId',
  name: 'name',
  specialInstructions: 'specialInstructions',
  patientFirstName: 'patientFirstName',
  patientLastName: 'patientLastName',
  patientMiddleName: 'patientMiddleName',
  patientNameSuffix: 'patientNameSuffix',
  patientAddress1: 'patientAddress1',
  patientAddress2: 'patientAddress2',
  patientCity: 'patientCity',
  patientState: 'patientState',
  patientZip: 'patientZip',
  patientMobilePhone: 'patientMobilePhone',
  patientHomePhone: 'patientHomePhone',
  patientEmail: 'patientEmail',
  patientDateOfBirth: 'patientDateOfBirth',
  patientSsn: 'patientSsn',
  patientSex: 'patientSex',
  heightInInches: 'heightInInches',
  weightInPounds: 'weightInPounds',
  bmi: 'bmi',
  surgeonId: 'surgeonId',
  additionalStaffId: 'additionalStaffId',
  guardianName: 'guardianName',
  guardianPhone: 'guardianPhone',
  guardianRelationship: 'guardianRelationship',
  expectedCaseLength: 'expectedCaseLength',
  roomTurnOverTime: 'roomTurnOverTime',
  asaClassification: 'asaClassification',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  acknowledgedAt: 'acknowledgedAt',
  healthReviewStatus: 'healthReviewStatus',
  anesthesiaType: 'anesthesiaType',
  arriveMinutesBeforeAppointment: 'arriveMinutesBeforeAppointment',
  referringPhysicianName: 'referringPhysicianName',
  referringPhysicianPhone: 'referringPhysicianPhone',
  patientId: 'patientId',
  overnightStay: 'overnightStay',
  messageThreadId: 'messageThreadId',
  facilityMessageThreadId: 'facilityMessageThreadId',
  prePaymentType: 'prePaymentType',
  prePaymentAmount: 'prePaymentAmount',
  prePaymentNotes: 'prePaymentNotes',
  prePaymentTransferredAt: 'prePaymentTransferredAt',
  createdFromSurgeryProfileId: 'createdFromSurgeryProfileId'
};

exports.Prisma.EncounterParticipantScalarFieldEnum = {
  id: 'id',
  encounterId: 'encounterId',
  staffId: 'staffId',
  actor: 'actor',
  jobRoleId: 'jobRoleId',
  roomId: 'roomId',
  eventTime: 'eventTime',
  direction: 'direction',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  point: 'point'
};

exports.Prisma.AssetTypeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  label: 'label'
};

exports.Prisma.AssetScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  assetTypeId: 'assetTypeId',
  encounterId: 'encounterId',
  patientId: 'patientId',
  storageBlobId: 'storageBlobId',
  name: 'name'
};

exports.Prisma.IntegrationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId',
  useExternalMrn: 'useExternalMrn',
  resolver: 'resolver',
  oneSchemaTemplate: 'oneSchemaTemplate'
};

exports.Prisma.RoomScalarFieldEnum = {
  id: 'id',
  name: 'name',
  active: 'active',
  facilityId: 'facilityId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PatientMedicationChangeScalarFieldEnum = {
  id: 'id',
  medicationId: 'medicationId',
  encounterId: 'encounterId',
  action: 'action',
  dose: 'dose',
  doseUnitsId: 'doseUnitsId',
  frequency: 'frequency',
  notes: 'notes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PatientMedicationScalarFieldEnum = {
  id: 'id',
  medication: 'medication',
  registrarId: 'registrarId',
  dosage: 'dosage',
  uom: 'uom',
  frequency: 'frequency',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  lastTakenAt: 'lastTakenAt',
  patientId: 'patientId',
  source: 'source',
  location: 'location',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OperativeMedsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  encounterId: 'encounterId',
  jobRoleType: 'jobRoleType'
};

exports.Prisma.OrderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  typeId: 'typeId',
  orderText: 'orderText',
  orderDate: 'orderDate',
  validFrom: 'validFrom',
  validUntil: 'validUntil',
  standingOrderId: 'standingOrderId',
  issuerId: 'issuerId',
  encounterId: 'encounterId',
  orderGroupId: 'orderGroupId'
};

exports.Prisma.OrderResponseScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orderId: 'orderId',
  status: 'status'
};

exports.Prisma.StandingMedicationOrderScalarFieldEnum = {
  id: 'id',
  standingOrderId: 'standingOrderId',
  medId: 'medId',
  registrarId: 'registrarId',
  doseageNumber: 'doseageNumber',
  doseageUomId: 'doseageUomId',
  frequency: 'frequency',
  route: 'route',
  site: 'site'
};

exports.Prisma.StandingOrderScalarFieldEnum = {
  id: 'id',
  providerId: 'providerId',
  emrTemplateId: 'emrTemplateId',
  orderText: 'orderText',
  typeId: 'typeId',
  phase: 'phase',
  validFrom: 'validFrom',
  validUntil: 'validUntil',
  orderGroupId: 'orderGroupId',
  sequenceNumber: 'sequenceNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  appliesByDefault: 'appliesByDefault'
};

exports.Prisma.OrderGroupScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  sequenceNumber: 'sequenceNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId'
};

exports.Prisma.OrganizationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  displayName: 'displayName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  clerkId: 'clerkId'
};

exports.Prisma.FacilityScalarFieldEnum = {
  id: 'id',
  name: 'name',
  organizationId: 'organizationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  defaultRoomTurnOverTimeInMinutes: 'defaultRoomTurnOverTimeInMinutes',
  defaultArriveMinutesBeforeAppointment: 'defaultArriveMinutesBeforeAppointment',
  timezone: 'timezone',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  phone: 'phone',
  fax: 'fax',
  email: 'email',
  earliestTime: 'earliestTime',
  latestTime: 'latestTime',
  highBmiFlagLevel: 'highBmiFlagLevel',
  allowSchedulingInOpenTime: 'allowSchedulingInOpenTime',
  mrnStrategy: 'mrnStrategy',
  mrnPrefix: 'mrnPrefix',
  sequentialMrnSequence: 'sequentialMrnSequence',
  labelTemplateId: 'labelTemplateId',
  patientInvoiceMessage: 'patientInvoiceMessage',
  ein: 'ein',
  npi: 'npi'
};

exports.Prisma.PracticeScalarFieldEnum = {
  id: 'id',
  name: 'name',
  organizationId: 'organizationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  phone: 'phone',
  fax: 'fax',
  email: 'email'
};

exports.Prisma.PatientCommunicationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId',
  patientId: 'patientId',
  encounterId: 'encounterId',
  userId: 'userId',
  channel: 'channel',
  to: 'to',
  message: 'message',
  preview: 'preview',
  context: 'context',
  sentAt: 'sentAt',
  error: 'error',
  templateId: 'templateId'
};

exports.Prisma.CommunicationTemplateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId',
  name: 'name',
  messageType: 'messageType',
  smsContentJson: 'smsContentJson',
  smsContentText: 'smsContentText',
  automaticallySend: 'automaticallySend',
  sendDeltaInDays: 'sendDeltaInDays',
  localHourOfDay: 'localHourOfDay'
};

exports.Prisma.PatientCommunicationWhitelistScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  channel: 'channel',
  to: 'to'
};

exports.Prisma.PatientNoteScalarFieldEnum = {
  id: 'id',
  encounterId: 'encounterId',
  authorId: 'authorId',
  authorName: 'authorName',
  notes: 'notes',
  key: 'key',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PayerRateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  payerId: 'payerId',
  periodStart: 'periodStart',
  periodEnd: 'periodEnd',
  rate: 'rate',
  procedure: 'procedure',
  organizationId: 'organizationId'
};

exports.Prisma.PayerRegionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  payerId: 'payerId'
};

exports.Prisma.ProviderEncounterDocumentScalarFieldEnum = {
  id: 'id',
  encounterDocumentId: 'encounterDocumentId',
  staffId: 'staffId'
};

exports.Prisma.QuestionnaireScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  name: 'name',
  latestVersion: 'latestVersion',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.QuestionnaireQuestionScalarFieldEnum = {
  id: 'id',
  questionnaireId: 'questionnaireId',
  version: 'version',
  label: 'label',
  subLabel: 'subLabel',
  fieldType: 'fieldType',
  valueType: 'valueType',
  ordinal: 'ordinal',
  parentQuestionId: 'parentQuestionId',
  repeatable: 'repeatable',
  readOnly: 'readOnly',
  required: 'required',
  choices: 'choices',
  published: 'published',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.QuestionnaireQuestionConditionScalarFieldEnum = {
  id: 'id',
  type: 'type',
  sourceQuestionnaireId: 'sourceQuestionnaireId',
  targetQuestionnaireId: 'targetQuestionnaireId',
  sourceQuestionId: 'sourceQuestionId',
  targetQuestionId: 'targetQuestionId',
  targetQuestionGroupRow: 'targetQuestionGroupRow',
  useSourceGroupRow: 'useSourceGroupRow',
  comparator: 'comparator',
  valueType: 'valueType',
  floatValue: 'floatValue',
  stringValue: 'stringValue',
  booleanValue: 'booleanValue',
  dateValue: 'dateValue',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.QuestionnaireResponseScalarFieldEnum = {
  id: 'id',
  encounterId: 'encounterId',
  questionnaireId: 'questionnaireId',
  questionnaireVersion: 'questionnaireVersion',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.QuestionnaireResponseAnswerScalarFieldEnum = {
  id: 'id',
  questionnaireResponseId: 'questionnaireResponseId',
  questionnaireQuestionId: 'questionnaireQuestionId',
  groupRow: 'groupRow',
  valueOrdinal: 'valueOrdinal',
  valueType: 'valueType',
  floatValue: 'floatValue',
  stringValue: 'stringValue',
  booleanValue: 'booleanValue',
  dateValue: 'dateValue',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PatientSignatureScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  patientId: 'patientId',
  blob: 'blob',
  representativeName: 'representativeName'
};

exports.Prisma.StaffSignatureScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  staffId: 'staffId',
  blob: 'blob',
  pin: 'pin'
};

exports.Prisma.SignatureScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  appliedAt: 'appliedAt',
  appliedJobRoleId: 'appliedJobRoleId',
  appliedPatientSignatureId: 'appliedPatientSignatureId',
  appliedStaffSignatureId: 'appliedStaffSignatureId',
  requiredJobRoleType: 'requiredJobRoleType'
};

exports.Prisma.ProcedureHistoryScalarFieldEnum = {
  id: 'id',
  procedureName: 'procedureName',
  patientId: 'patientId',
  encounterId: 'encounterId',
  performedAt: 'performedAt',
  performedAtApproximate: 'performedAtApproximate',
  performedAtText: 'performedAtText',
  complications: 'complications',
  reason: 'reason',
  bodySiteText: 'bodySiteText',
  outcome: 'outcome',
  notes: 'notes',
  device: 'device',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SurgicalTimeoutScalarFieldEnum = {
  id: 'id',
  confirmPatientIdentity: 'confirmPatientIdentity',
  confirmSiteSideLaterality: 'confirmSiteSideLaterality',
  confirmProcedure: 'confirmProcedure',
  confirmPosition: 'confirmPosition',
  confirmConsent: 'confirmConsent',
  confirmAvailabilityOfImplants: 'confirmAvailabilityOfImplants',
  reviewedSpecificPatientConcerns: 'reviewedSpecificPatientConcerns',
  reviewedEquipmentConcernsSterilitySafety: 'reviewedEquipmentConcernsSterilitySafety',
  antibioticPropylaxisGiven: 'antibioticPropylaxisGiven',
  markingVisible: 'markingVisible',
  clinicalEventId: 'clinicalEventId'
};

exports.Prisma.StaffVersionScalarFieldEnum = {
  versionId: 'versionId',
  versionOperation: 'versionOperation',
  versionSourceId: 'versionSourceId',
  versionUserId: 'versionUserId',
  versionTimestamp: 'versionTimestamp',
  id: 'id',
  userId: 'userId',
  organizationId: 'organizationId',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  firstName: 'firstName',
  middleName: 'middleName',
  lastName: 'lastName',
  qualification: 'qualification',
  email: 'email',
  mobilePhone: 'mobilePhone',
  officePhone: 'officePhone',
  providerSpecialtyId: 'providerSpecialtyId',
  npi: 'npi',
  taxonomyCode: 'taxonomyCode',
  stateLicenseNumber: 'stateLicenseNumber',
  upin: 'upin'
};

exports.Prisma.PreferenceCardVersionScalarFieldEnum = {
  versionId: 'versionId',
  versionOperation: 'versionOperation',
  versionSourceId: 'versionSourceId',
  versionUserId: 'versionUserId',
  versionTimestamp: 'versionTimestamp',
  id: 'id',
  title: 'title',
  providerId: 'providerId',
  positioning: 'positioning',
  prep: 'prep',
  drapes: 'drapes',
  notes: 'notes',
  gloves: 'gloves',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId',
  deepUpdatedAt: 'deepUpdatedAt'
};

exports.Prisma.EquipmentVersionScalarFieldEnum = {
  versionId: 'versionId',
  versionOperation: 'versionOperation',
  versionSourceId: 'versionSourceId',
  versionUserId: 'versionUserId',
  versionTimestamp: 'versionTimestamp',
  id: 'id',
  name: 'name',
  type: 'type',
  active: 'active',
  inventoryNumber: 'inventoryNumber',
  supplierNumber: 'supplierNumber',
  supplierId: 'supplierId',
  supplierRepId: 'supplierRepId',
  organizationId: 'organizationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EquipmentRequirementVersionScalarFieldEnum = {
  versionId: 'versionId',
  versionOperation: 'versionOperation',
  versionSourceId: 'versionSourceId',
  versionUserId: 'versionUserId',
  versionTimestamp: 'versionTimestamp',
  id: 'id',
  caseId: 'caseId',
  equipmentId: 'equipmentId',
  quantity: 'quantity',
  status: 'status',
  representativeStatus: 'representativeStatus',
  requiredAtOperation: 'requiredAtOperation'
};

exports.Prisma.ProcedureVersionScalarFieldEnum = {
  versionId: 'versionId',
  versionOperation: 'versionOperation',
  versionSourceId: 'versionSourceId',
  versionUserId: 'versionUserId',
  versionTimestamp: 'versionTimestamp',
  id: 'id',
  cptCodeId: 'cptCodeId',
  caseId: 'caseId',
  description: 'description',
  laterality: 'laterality',
  possible: 'possible',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PaymentInsuranceVersionScalarFieldEnum = {
  versionId: 'versionId',
  versionOperation: 'versionOperation',
  versionSourceId: 'versionSourceId',
  versionUserId: 'versionUserId',
  versionTimestamp: 'versionTimestamp',
  id: 'id',
  caseId: 'caseId',
  name: 'name',
  member: 'member',
  firstName: 'firstName',
  lastName: 'lastName',
  middleName: 'middleName',
  relationship: 'relationship',
  policyNumber: 'policyNumber',
  groupNumber: 'groupNumber',
  primary: 'primary',
  preAuthStatus: 'preAuthStatus',
  preAuthValidated: 'preAuthValidated',
  preAuthRequired: 'preAuthRequired',
  authorizationNumber: 'authorizationNumber',
  insuranceRepName: 'insuranceRepName',
  insuranceRepPhone: 'insuranceRepPhone',
  insuranceRepEmail: 'insuranceRepEmail',
  preCertNumber: 'preCertNumber',
  preCertDate: 'preCertDate',
  preCertValidStart: 'preCertValidStart',
  preCertValidEnd: 'preCertValidEnd',
  deductibleInDollars: 'deductibleInDollars',
  deductibleMetInDollars: 'deductibleMetInDollars',
  deductibleRemaining: 'deductibleRemaining',
  outOfPocketInDollars: 'outOfPocketInDollars',
  outOfPocketMetInDollars: 'outOfPocketMetInDollars',
  outOfPocketRemaining: 'outOfPocketRemaining',
  coinsurancePercentage: 'coinsurancePercentage',
  facilityFeeInDollars: 'facilityFeeInDollars',
  anesthesiaFeeInDollars: 'anesthesiaFeeInDollars',
  coPayInDollars: 'coPayInDollars',
  notes: 'notes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  patientNoteId: 'patientNoteId',
  insuranceVerified: 'insuranceVerified',
  insuranceVerifiedAt: 'insuranceVerifiedAt',
  stediVerificationCount: 'stediVerificationCount',
  networkContract: 'networkContract',
  providerId: 'providerId',
  otherInsurerName: 'otherInsurerName',
  isInsuranceUnlisted: 'isInsuranceUnlisted'
};

exports.Prisma.PaymentWorkersCompVersionScalarFieldEnum = {
  versionId: 'versionId',
  versionOperation: 'versionOperation',
  versionSourceId: 'versionSourceId',
  versionUserId: 'versionUserId',
  versionTimestamp: 'versionTimestamp',
  id: 'id',
  caseId: 'caseId',
  carrier: 'carrier',
  claimNumber: 'claimNumber',
  address: 'address',
  authorizationNumber: 'authorizationNumber',
  adjustor: 'adjustor',
  adjustorPhone: 'adjustorPhone',
  dateOfInjury: 'dateOfInjury',
  notes: 'notes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  providerId: 'providerId'
};

exports.Prisma.PaymentSelfPayVersionScalarFieldEnum = {
  versionId: 'versionId',
  versionOperation: 'versionOperation',
  versionSourceId: 'versionSourceId',
  versionUserId: 'versionUserId',
  versionTimestamp: 'versionTimestamp',
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  caseId: 'caseId',
  paymentMethodTypeId: 'paymentMethodTypeId',
  practiceCollectsAllPayment: 'practiceCollectsAllPayment',
  practiceCollectsProviderPayment: 'practiceCollectsProviderPayment',
  notes: 'notes'
};

exports.Prisma.DiagnosisVersionScalarFieldEnum = {
  versionId: 'versionId',
  versionOperation: 'versionOperation',
  versionSourceId: 'versionSourceId',
  versionUserId: 'versionUserId',
  versionTimestamp: 'versionTimestamp',
  id: 'id',
  conditionId: 'conditionId',
  caseId: 'caseId',
  icd10: 'icd10',
  reporter: 'reporter',
  status: 'status',
  effective: 'effective',
  invalidated: 'invalidated',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CaseVersionScalarFieldEnum = {
  versionId: 'versionId',
  versionOperation: 'versionOperation',
  versionSourceId: 'versionSourceId',
  versionUserId: 'versionUserId',
  versionTimestamp: 'versionTimestamp',
  id: 'id',
  financialReference: 'financialReference',
  requestedById: 'requestedById',
  createdBy: 'createdBy',
  status: 'status',
  cancellationReason: 'cancellationReason',
  surgeryDate: 'surgeryDate',
  roomId: 'roomId',
  facilityId: 'facilityId',
  practiceId: 'practiceId',
  name: 'name',
  specialInstructions: 'specialInstructions',
  patientFirstName: 'patientFirstName',
  patientLastName: 'patientLastName',
  patientMiddleName: 'patientMiddleName',
  patientNameSuffix: 'patientNameSuffix',
  patientAddress1: 'patientAddress1',
  patientAddress2: 'patientAddress2',
  patientCity: 'patientCity',
  patientState: 'patientState',
  patientZip: 'patientZip',
  patientMobilePhone: 'patientMobilePhone',
  patientHomePhone: 'patientHomePhone',
  patientEmail: 'patientEmail',
  patientDateOfBirth: 'patientDateOfBirth',
  patientSsn: 'patientSsn',
  patientSex: 'patientSex',
  heightInInches: 'heightInInches',
  weightInPounds: 'weightInPounds',
  bmi: 'bmi',
  surgeonId: 'surgeonId',
  additionalStaffId: 'additionalStaffId',
  guardianName: 'guardianName',
  guardianPhone: 'guardianPhone',
  guardianRelationship: 'guardianRelationship',
  expectedCaseLength: 'expectedCaseLength',
  roomTurnOverTime: 'roomTurnOverTime',
  asaClassification: 'asaClassification',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  acknowledgedAt: 'acknowledgedAt',
  healthReviewStatus: 'healthReviewStatus',
  anesthesiaType: 'anesthesiaType',
  arriveMinutesBeforeAppointment: 'arriveMinutesBeforeAppointment',
  referringPhysicianName: 'referringPhysicianName',
  referringPhysicianPhone: 'referringPhysicianPhone',
  patientId: 'patientId',
  overnightStay: 'overnightStay',
  messageThreadId: 'messageThreadId',
  facilityMessageThreadId: 'facilityMessageThreadId',
  prePaymentType: 'prePaymentType',
  prePaymentAmount: 'prePaymentAmount',
  prePaymentNotes: 'prePaymentNotes',
  prePaymentTransferredAt: 'prePaymentTransferredAt',
  createdFromSurgeryProfileId: 'createdFromSurgeryProfileId'
};

exports.Prisma.RoomVersionScalarFieldEnum = {
  versionId: 'versionId',
  versionOperation: 'versionOperation',
  versionSourceId: 'versionSourceId',
  versionUserId: 'versionUserId',
  versionTimestamp: 'versionTimestamp',
  id: 'id',
  name: 'name',
  active: 'active',
  facilityId: 'facilityId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ChargeAllocationsViewScalarFieldEnum = {
  billingChargeId: 'billingChargeId',
  billingChargeMasterId: 'billingChargeMasterId',
  chargeCode: 'chargeCode',
  billingCaseId: 'billingCaseId',
  organizationId: 'organizationId',
  billingPayerId: 'billingPayerId',
  sequenceNumber: 'sequenceNumber',
  payerType: 'payerType',
  billingClaimId: 'billingClaimId',
  billingClaimStatus: 'billingClaimStatus',
  claimGeneratedAt: 'claimGeneratedAt',
  claimSubmittedAt: 'claimSubmittedAt',
  billedAmount: 'billedAmount',
  paymentAmount: 'paymentAmount',
  adjustmentAmount: 'adjustmentAmount',
  patientResponsiblityAmount: 'patientResponsiblityAmount',
  transactionDate: 'transactionDate'
};

exports.Prisma.ChargePayerAmountViewScalarFieldEnum = {
  billingChargeId: 'billingChargeId',
  billingChargeMasterId: 'billingChargeMasterId',
  chargeCode: 'chargeCode',
  billingCaseId: 'billingCaseId',
  billingPayerId: 'billingPayerId',
  sequenceNumber: 'sequenceNumber',
  payerType: 'payerType',
  payerName: 'payerName',
  policyNumber: 'policyNumber',
  groupNumber: 'groupNumber',
  billingClaimId: 'billingClaimId',
  billingClaimStatus: 'billingClaimStatus',
  claimGeneratedAt: 'claimGeneratedAt',
  claimSubmittedAt: 'claimSubmittedAt',
  patientId: 'patientId',
  patientName: 'patientName',
  patientMrn: 'patientMrn',
  patientDateOfBirth: 'patientDateOfBirth',
  organizationId: 'organizationId',
  financialReference: 'financialReference',
  dateOfService: 'dateOfService',
  providerId: 'providerId',
  providerName: 'providerName',
  billedAmount: 'billedAmount',
  priorPayersAmount: 'priorPayersAmount',
  expectedAmount: 'expectedAmount',
  adjustmentAmount: 'adjustmentAmount',
  paymentAmount: 'paymentAmount',
  outstandingAmount: 'outstandingAmount',
  transactionDate: 'transactionDate'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.BulkCreateSource = exports.$Enums.BulkCreateSource = {
  One_Schema: 'One_Schema',
  Procision_EMR_Vitals: 'Procision_EMR_Vitals',
  Procision_EMR_ParScore: 'Procision_EMR_ParScore',
  Procision_EMR_DVT_Risk_Assessment: 'Procision_EMR_DVT_Risk_Assessment',
  Procision_EMR_Fall_Risk_Assessment: 'Procision_EMR_Fall_Risk_Assessment',
  Procision_EMR_PONV_Risk_Assessment: 'Procision_EMR_PONV_Risk_Assessment',
  Procision_EMR_STOP_BANG_Risk_Assessment: 'Procision_EMR_STOP_BANG_Risk_Assessment',
  HL7_Message: 'HL7_Message'
};

exports.BulkCreateDestination = exports.$Enums.BulkCreateDestination = {
  Case: 'Case',
  ChargeMaster: 'ChargeMaster',
  ClinicalEvent: 'ClinicalEvent'
};

exports.DaysOfWeek = exports.$Enums.DaysOfWeek = {
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY'
};

exports.TimePeriodType = exports.$Enums.TimePeriodType = {
  CLOSED: 'CLOSED',
  BLOCKTIME: 'BLOCKTIME',
  HOLIDAY: 'HOLIDAY',
  OPEN: 'OPEN'
};

exports.IntervalUnit = exports.$Enums.IntervalUnit = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  YEAR: 'YEAR'
};

exports.RecurrenceMethod = exports.$Enums.RecurrenceMethod = {
  INTERVAL: 'INTERVAL',
  DAY_OF_WEEK: 'DAY_OF_WEEK'
};

exports.EquipmentType = exports.$Enums.EquipmentType = {
  DME: 'DME',
  IMPLANT: 'IMPLANT',
  INSTRUMENTATION: 'INSTRUMENTATION',
  DISPOSABLE: 'DISPOSABLE',
  EQUIPMENT: 'EQUIPMENT',
  DRESSING: 'DRESSING',
  MEDICATION: 'MEDICATION',
  SUTURE: 'SUTURE'
};

exports.EquipmentRequirementStatus = exports.$Enums.EquipmentRequirementStatus = {
  PENDING: 'PENDING',
  ORDERED: 'ORDERED',
  IN_INVENTORY: 'IN_INVENTORY',
  REP_BRINGING: 'REP_BRINGING'
};

exports.EquipmentRequirementRepresentativeStatus = exports.$Enums.EquipmentRequirementRepresentativeStatus = {
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
  NOT_REQUIRED: 'NOT_REQUIRED'
};

exports.Laterality = exports.$Enums.Laterality = {
  Left: 'Left',
  Right: 'Right',
  Bilateral: 'Bilateral',
  None: 'None'
};

exports.InsuredRelationship = exports.$Enums.InsuredRelationship = {
  SELF: 'SELF',
  SPOUSE: 'SPOUSE',
  CHILD: 'CHILD',
  OTHER: 'OTHER'
};

exports.PreAuthStatus = exports.$Enums.PreAuthStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DENIED: 'DENIED',
  PEER_TO_PEER: 'PEER_TO_PEER',
  NOT_REQUIRED: 'NOT_REQUIRED',
  OTHER: 'OTHER'
};

exports.NetworkContractStatus = exports.$Enums.NetworkContractStatus = {
  IN_NETWORK: 'IN_NETWORK',
  OUT_OF_NETWORK: 'OUT_OF_NETWORK'
};

exports.JobRoleType = exports.$Enums.JobRoleType = {
  SURGEON: 'SURGEON',
  ANESTHESIOLOGIST: 'ANESTHESIOLOGIST',
  NURSE: 'NURSE',
  PATIENT: 'PATIENT',
  WITNESS: 'WITNESS'
};

exports.TagType = exports.$Enums.TagType = {
  MEDICAL_CONDITION: 'MEDICAL_CONDITION',
  FINANCE: 'FINANCE'
};

exports.HealthReviewRequirementsStatus = exports.$Enums.HealthReviewRequirementsStatus = {
  MISSING: 'MISSING',
  READY: 'READY'
};

exports.HealthReviewStatus = exports.$Enums.HealthReviewStatus = {
  INCOMPLETE: 'INCOMPLETE',
  PENDING_ANESTH_REVIEW: 'PENDING_ANESTH_REVIEW',
  PENDING_NURSE_REVIEW: 'PENDING_NURSE_REVIEW',
  ATTENTION: 'ATTENTION',
  CANCELLED: 'CANCELLED',
  COMPLETE: 'COMPLETE'
};

exports.BillingPayerType = exports.$Enums.BillingPayerType = {
  Insurance: 'Insurance',
  Workers_Comp: 'Workers_Comp',
  Self_Pay: 'Self_Pay',
  Letter_Of_Protection: 'Letter_Of_Protection'
};

exports.BillingCaseStatus = exports.$Enums.BillingCaseStatus = {
  Not_Billable: 'Not_Billable',
  New: 'New',
  Billed: 'Billed',
  Done: 'Done'
};

exports.BillingClaimStatus = exports.$Enums.BillingClaimStatus = {
  New: 'New',
  Ready_to_Submit: 'Ready_to_Submit',
  Provisional: 'Provisional',
  Billed: 'Billed',
  Voided: 'Voided',
  Denied: 'Denied',
  Disputed: 'Disputed',
  Done: 'Done',
  Send_to_Collections: 'Send_to_Collections',
  In_Collections: 'In_Collections'
};

exports.BillingTransactionStatus = exports.$Enums.BillingTransactionStatus = {
  New: 'New',
  In_Progress: 'In_Progress',
  Complete: 'Complete',
  Closed: 'Closed'
};

exports.PaymentType = exports.$Enums.PaymentType = {
  Check: 'Check',
  Cash: 'Cash',
  Credit_Card: 'Credit_Card',
  Electronic_Funds_Transfer: 'Electronic_Funds_Transfer',
  Money_Order: 'Money_Order',
  Other: 'Other'
};

exports.AdjustmentReportType = exports.$Enums.AdjustmentReportType = {
  Adjustment: 'Adjustment',
  Write_Off: 'Write_Off'
};

exports.X12ClaimAdjustmentCodeGroup = exports.$Enums.X12ClaimAdjustmentCodeGroup = {
  CO: 'CO',
  CR: 'CR',
  OA: 'OA',
  PI: 'PI',
  PR: 'PR'
};

exports.BillingTransactionAllocationStatus = exports.$Enums.BillingTransactionAllocationStatus = {
  Draft: 'Draft',
  Posted: 'Posted'
};

exports.ConsentFormType = exports.$Enums.ConsentFormType = {
  Electronic: 'Electronic',
  Paper: 'Paper'
};

exports.ConsentStatus = exports.$Enums.ConsentStatus = {
  Assigned: 'Assigned',
  Signed: 'Signed',
  Refused: 'Refused'
};

exports.ProcedureCodeKind = exports.$Enums.ProcedureCodeKind = {
  CPT: 'CPT',
  HCPCS: 'HCPCS'
};

exports.Sex = exports.$Enums.Sex = {
  Male: 'Male',
  Female: 'Female'
};

exports.DiagnosisReporter = exports.$Enums.DiagnosisReporter = {
  PATIENT: 'PATIENT',
  PROVIDER: 'PROVIDER',
  OTHER: 'OTHER'
};

exports.ConditionState = exports.$Enums.ConditionState = {
  YES: 'YES',
  NO: 'NO',
  UNKNOWN: 'UNKNOWN',
  HISTORICAL: 'HISTORICAL'
};

exports.AllergySeverity = exports.$Enums.AllergySeverity = {
  Sensitivity: 'Sensitivity',
  Allergy: 'Allergy'
};

exports.AnesthesiaType = exports.$Enums.AnesthesiaType = {
  GENERAL: 'GENERAL',
  LOCAL: 'LOCAL',
  NONE: 'NONE',
  MAC: 'MAC',
  BLOCK: 'BLOCK',
  IV_SEDATION: 'IV_SEDATION'
};

exports.ClinicalEventResultType = exports.$Enums.ClinicalEventResultType = {
  Text: 'Text',
  Int: 'Int',
  Float: 'Float',
  CodeableConceptValue: 'CodeableConceptValue'
};

exports.ListRuleOperation = exports.$Enums.ListRuleOperation = {
  Percent_of_Medicare: 'Percent_of_Medicare'
};

exports.ListRuleCondition = exports.$Enums.ListRuleCondition = {
  GT: 'GT',
  GTE: 'GTE',
  EQ: 'EQ',
  LTE: 'LTE',
  LT: 'LT'
};

exports.ContractProcedureFlag = exports.$Enums.ContractProcedureFlag = {
  Exempt_From_Multiple_Procedure_Rules: 'Exempt_From_Multiple_Procedure_Rules'
};

exports.PayerRateRule = exports.$Enums.PayerRateRule = {
  Prior_October_as_of_November_1st: 'Prior_October_as_of_November_1st',
  Same_Quarter_as_DOS: 'Same_Quarter_as_DOS'
};

exports.EmrTemplateWorkflowType = exports.$Enums.EmrTemplateWorkflowType = {
  PAT: 'PAT',
  Preop: 'Preop',
  Anesthesia: 'Anesthesia',
  Operative: 'Operative',
  Postop: 'Postop',
  PacuPhase1: 'PacuPhase1',
  PacuPhase2: 'PacuPhase2',
  PostopPhoneCall: 'PostopPhoneCall',
  PatientPrintout: 'PatientPrintout'
};

exports.EmrTemplateStatus = exports.$Enums.EmrTemplateStatus = {
  Draft: 'Draft',
  Published: 'Published',
  Archived: 'Archived'
};

exports.EmrSectionType = exports.$Enums.EmrSectionType = {
  Questionnaire: 'Questionnaire',
  MedicationList: 'MedicationList',
  MedicationReconciliation: 'MedicationReconciliation',
  MedicationAdministration: 'MedicationAdministration',
  AllergyList: 'AllergyList',
  SurgicalHistory: 'SurgicalHistory',
  SurgicalTimeout: 'SurgicalTimeout',
  PatientKeyPoint: 'PatientKeyPoint',
  PatientDemographics: 'PatientDemographics',
  Conditions: 'Conditions',
  Notes: 'Notes',
  ChargeNurse: 'ChargeNurse',
  InHouseTests: 'InHouseTests',
  Orders: 'Orders',
  Vitals: 'Vitals',
  ParScore: 'ParScore',
  RiskAssessment: 'RiskAssessment',
  Bmi: 'Bmi',
  QuickMenu: 'QuickMenu',
  Document: 'Document',
  SurgeryDetails: 'SurgeryDetails',
  ClinicalEvents: 'ClinicalEvents',
  OrMedications: 'OrMedications',
  Ins_and_Outs: 'Ins_and_Outs'
};

exports.ReviewStatus = exports.$Enums.ReviewStatus = {
  Draft: 'Draft',
  Unreviewed: 'Unreviewed',
  Invalid: 'Invalid',
  Reviewed: 'Reviewed'
};

exports.PatientSubmissionStatus = exports.$Enums.PatientSubmissionStatus = {
  None: 'None',
  Matched: 'Matched',
  Merged: 'Merged',
  Reviewed: 'Reviewed'
};

exports.EncounterStatus = exports.$Enums.EncounterStatus = {
  Planned: 'Planned',
  Arrived: 'Arrived',
  CheckedIn: 'CheckedIn',
  InProgress: 'InProgress',
  OnLeave: 'OnLeave',
  Finished: 'Finished',
  Canceled: 'Canceled'
};

exports.PatStatus = exports.$Enums.PatStatus = {
  Incomplete: 'Incomplete',
  Complete: 'Complete'
};

exports.OrganizationType = exports.$Enums.OrganizationType = {
  PRACTICE: 'PRACTICE',
  FACILITY: 'FACILITY'
};

exports.CaseStatus = exports.$Enums.CaseStatus = {
  Draft: 'Draft',
  Abandoned: 'Abandoned',
  Requested: 'Requested',
  Denied: 'Denied',
  Accepted: 'Accepted',
  Late: 'Late',
  Arrived: 'Arrived',
  Checked_In: 'Checked_In',
  In_PreOp: 'In_PreOp',
  Ready_for_OR: 'Ready_for_OR',
  In_OR: 'In_OR',
  Recovery: 'Recovery',
  Discharged: 'Discharged',
  Partially_Completed: 'Partially_Completed',
  Completed: 'Completed',
  Canceled: 'Canceled'
};

exports.AsaClassification = exports.$Enums.AsaClassification = {
  ASA_1: 'ASA_1',
  ASA_2: 'ASA_2',
  ASA_3: 'ASA_3',
  ASA_4: 'ASA_4',
  ASA_5: 'ASA_5',
  ASA_6: 'ASA_6'
};

exports.CaseActor = exports.$Enums.CaseActor = {
  PATIENT: 'PATIENT',
  STAFF: 'STAFF',
  FACILITY: 'FACILITY',
  PROCEDURE: 'PROCEDURE'
};

exports.Direction = exports.$Enums.Direction = {
  IN: 'IN',
  OUT: 'OUT'
};

exports.CaseKeyPoint = exports.$Enums.CaseKeyPoint = {
  Arrived: 'Arrived',
  Checked_In: 'Checked_In',
  In_PreOp: 'In_PreOp',
  Ready_for_OR: 'Ready_for_OR',
  In_OR: 'In_OR',
  Anesthesia_Start: 'Anesthesia_Start',
  Operation_Start: 'Operation_Start',
  Operation_Completed: 'Operation_Completed',
  Recovery: 'Recovery',
  Discharged: 'Discharged',
  Anesthesia_End: 'Anesthesia_End',
  Pacu_Phase_2_Start: 'Pacu_Phase_2_Start'
};

exports.BulkResolverAlgorithm = exports.$Enums.BulkResolverAlgorithm = {
  Add_All: 'Add_All',
  Sync: 'Sync'
};

exports.PatientMedicationReconciliation = exports.$Enums.PatientMedicationReconciliation = {
  Continue: 'Continue',
  Stop: 'Stop',
  Start: 'Start',
  Change: 'Change'
};

exports.PatientMedicationSource = exports.$Enums.PatientMedicationSource = {
  Patient: 'Patient',
  Clinician: 'Clinician'
};

exports.MedicationLocation = exports.$Enums.MedicationLocation = {
  Home: 'Home'
};

exports.OrderStatus = exports.$Enums.OrderStatus = {
  Standing: 'Standing',
  Draft: 'Draft',
  Issued: 'Issued',
  Invalidated: 'Invalidated'
};

exports.OrderResponseStatus = exports.$Enums.OrderResponseStatus = {
  Issued: 'Issued',
  Partially_Completed: 'Partially_Completed',
  Completed: 'Completed',
  Refused: 'Refused'
};

exports.MrnStrategy = exports.$Enums.MrnStrategy = {
  SEQUENTIAL: 'SEQUENTIAL',
  CUID: 'CUID'
};

exports.CommunicationChannel = exports.$Enums.CommunicationChannel = {
  SMS: 'SMS'
};

exports.PatientCommunicationError = exports.$Enums.PatientCommunicationError = {
  NO_ERROR: 'NO_ERROR',
  INVALID_PHONE_NUMBER: 'INVALID_PHONE_NUMBER',
  UNSUBSCRIBED: 'UNSUBSCRIBED',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  NOT_WHITELISTED: 'NOT_WHITELISTED'
};

exports.MessageType = exports.$Enums.MessageType = {
  Prompt_to_complete_PAT: 'Prompt_to_complete_PAT',
  PAT_Reminder: 'PAT_Reminder',
  Appointment_Reminder: 'Appointment_Reminder',
  Post_Appointment_Survey: 'Post_Appointment_Survey'
};

exports.QuestionFieldType = exports.$Enums.QuestionFieldType = {
  text: 'text',
  number: 'number',
  textArea: 'textArea',
  email: 'email',
  phone: 'phone',
  date: 'date',
  time: 'time',
  choice: 'choice',
  radio: 'radio',
  boolean: 'boolean',
  ssn: 'ssn',
  group: 'group',
  label: 'label',
  header: 'header',
  horizontalLine: 'horizontalLine'
};

exports.QuestionValueType = exports.$Enums.QuestionValueType = {
  floatValue: 'floatValue',
  stringValue: 'stringValue',
  booleanValue: 'booleanValue',
  dateValue: 'dateValue'
};

exports.QuestionConditionType = exports.$Enums.QuestionConditionType = {
  displayIf: 'displayIf'
};

exports.QuestionConditionComparator = exports.$Enums.QuestionConditionComparator = {
  equals: 'equals',
  notEquals: 'notEquals',
  exists: 'exists',
  notExists: 'notExists',
  greaterThan: 'greaterThan',
  greaterThanEqual: 'greaterThanEqual',
  lessThan: 'lessThan',
  lessThanEqual: 'lessThanEqual'
};

exports.YesNoNotApplicable = exports.$Enums.YesNoNotApplicable = {
  YES: 'YES',
  NO: 'NO',
  NOT_APPLICABLE: 'NOT_APPLICABLE'
};

exports.AuditOperation = exports.$Enums.AuditOperation = {
  INSERT: 'INSERT',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE'
};

exports.Prisma.ModelName = {
  User: 'User',
  TextTemplate: 'TextTemplate',
  MessageThread: 'MessageThread',
  Message: 'Message',
  Address: 'Address',
  StorageBlob: 'StorageBlob',
  Bucket: 'Bucket',
  InternalMigration: 'InternalMigration',
  BulkCreate: 'BulkCreate',
  Staff: 'Staff',
  FacilityHours: 'FacilityHours',
  Role: 'Role',
  TimePeriod: 'TimePeriod',
  TimePeriodSchedule: 'TimePeriodSchedule',
  PreferenceCard: 'PreferenceCard',
  Equipment: 'Equipment',
  PreferenceCardEquipment: 'PreferenceCardEquipment',
  CasePreferenceCard: 'CasePreferenceCard',
  CasePreferenceCardEquipment: 'CasePreferenceCardEquipment',
  Specialty: 'Specialty',
  Supplier: 'Supplier',
  SupplierRep: 'SupplierRep',
  EquipmentRequirement: 'EquipmentRequirement',
  Procedure: 'Procedure',
  AttachmentType: 'AttachmentType',
  Attachment: 'Attachment',
  InsuranceProvider: 'InsuranceProvider',
  WorkersCompProvider: 'WorkersCompProvider',
  WaystarInsuranceProvider: 'WaystarInsuranceProvider',
  WaystarPayerGroup: 'WaystarPayerGroup',
  PaymentInsuranceAttachmentType: 'PaymentInsuranceAttachmentType',
  PaymentInsuranceAttachment: 'PaymentInsuranceAttachment',
  PaymentWorkersCompAttachmentType: 'PaymentWorkersCompAttachmentType',
  PaymentWorkersCompAttachment: 'PaymentWorkersCompAttachment',
  PaymentInsurance: 'PaymentInsurance',
  PaymentWorkersComp: 'PaymentWorkersComp',
  PaymentSelfPay: 'PaymentSelfPay',
  PaymentLetterProtection: 'PaymentLetterProtection',
  PaymentMethodType: 'PaymentMethodType',
  JobRole: 'JobRole',
  OrganizationRelationship: 'OrganizationRelationship',
  CaseRole: 'CaseRole',
  Tag: 'Tag',
  HealthReviewType: 'HealthReviewType',
  HealthReviewCondition: 'HealthReviewCondition',
  HealthReviewRequirement: 'HealthReviewRequirement',
  HealthReviewRequirementAttachment: 'HealthReviewRequirementAttachment',
  MedicalCondition: 'MedicalCondition',
  CaseMedicalCondition: 'CaseMedicalCondition',
  CaseStatusTracker: 'CaseStatusTracker',
  BillingPayer: 'BillingPayer',
  BillingCase: 'BillingCase',
  BillingDiagnosis: 'BillingDiagnosis',
  BillingModifier: 'BillingModifier',
  BillingCharge: 'BillingCharge',
  BillingChargeModifier: 'BillingChargeModifier',
  BillingClaim: 'BillingClaim',
  BillingChargeMaster: 'BillingChargeMaster',
  BillingTransaction: 'BillingTransaction',
  BillingOrganization: 'BillingOrganization',
  BillingAdjustment: 'BillingAdjustment',
  BillingTransactionAllocation: 'BillingTransactionAllocation',
  BillingCaseAttachmentType: 'BillingCaseAttachmentType',
  BillingCaseAttachment: 'BillingCaseAttachment',
  ConsentForm: 'ConsentForm',
  PatientConsent: 'PatientConsent',
  CptCode: 'CptCode',
  Condition: 'Condition',
  CodeableConcept: 'CodeableConcept',
  Patient: 'Patient',
  Diagnosis: 'Diagnosis',
  Allergy: 'Allergy',
  PatientCondition: 'PatientCondition',
  SurgeryProfile: 'SurgeryProfile',
  SurgeryProfileDiagnosis: 'SurgeryProfileDiagnosis',
  SurgeryProfileCharge: 'SurgeryProfileCharge',
  ClinicalEvent: 'ClinicalEvent',
  MedicationAdministrationRecord: 'MedicationAdministrationRecord',
  Line: 'Line',
  ClinicalEventDimension: 'ClinicalEventDimension',
  ContractModifierWeight: 'ContractModifierWeight',
  ContractMultipleProcedureReimbursementRate: 'ContractMultipleProcedureReimbursementRate',
  ContractListRule: 'ContractListRule',
  ContractList: 'ContractList',
  ContractListMember: 'ContractListMember',
  ContractProcedureMetadata: 'ContractProcedureMetadata',
  Contract: 'Contract',
  DocumentTemplate: 'DocumentTemplate',
  EmrTemplate: 'EmrTemplate',
  EmrTemplatePage: 'EmrTemplatePage',
  EmrTemplateSection: 'EmrTemplateSection',
  PublicSubmission: 'PublicSubmission',
  EncounterDocument: 'EncounterDocument',
  Encounter: 'Encounter',
  EncounterClosure: 'EncounterClosure',
  EncounterWorkflow: 'EncounterWorkflow',
  EncounterWorkflowSignature: 'EncounterWorkflowSignature',
  Case: 'Case',
  EncounterParticipant: 'EncounterParticipant',
  AssetType: 'AssetType',
  Asset: 'Asset',
  Integration: 'Integration',
  Room: 'Room',
  PatientMedicationChange: 'PatientMedicationChange',
  PatientMedication: 'PatientMedication',
  OperativeMeds: 'OperativeMeds',
  Order: 'Order',
  OrderResponse: 'OrderResponse',
  StandingMedicationOrder: 'StandingMedicationOrder',
  StandingOrder: 'StandingOrder',
  OrderGroup: 'OrderGroup',
  Organization: 'Organization',
  Facility: 'Facility',
  Practice: 'Practice',
  PatientCommunication: 'PatientCommunication',
  CommunicationTemplate: 'CommunicationTemplate',
  PatientCommunicationWhitelist: 'PatientCommunicationWhitelist',
  PatientNote: 'PatientNote',
  PayerRate: 'PayerRate',
  PayerRegion: 'PayerRegion',
  ProviderEncounterDocument: 'ProviderEncounterDocument',
  Questionnaire: 'Questionnaire',
  QuestionnaireQuestion: 'QuestionnaireQuestion',
  QuestionnaireQuestionCondition: 'QuestionnaireQuestionCondition',
  QuestionnaireResponse: 'QuestionnaireResponse',
  QuestionnaireResponseAnswer: 'QuestionnaireResponseAnswer',
  PatientSignature: 'PatientSignature',
  StaffSignature: 'StaffSignature',
  Signature: 'Signature',
  ProcedureHistory: 'ProcedureHistory',
  SurgicalTimeout: 'SurgicalTimeout',
  StaffVersion: 'StaffVersion',
  PreferenceCardVersion: 'PreferenceCardVersion',
  EquipmentVersion: 'EquipmentVersion',
  EquipmentRequirementVersion: 'EquipmentRequirementVersion',
  ProcedureVersion: 'ProcedureVersion',
  PaymentInsuranceVersion: 'PaymentInsuranceVersion',
  PaymentWorkersCompVersion: 'PaymentWorkersCompVersion',
  PaymentSelfPayVersion: 'PaymentSelfPayVersion',
  DiagnosisVersion: 'DiagnosisVersion',
  CaseVersion: 'CaseVersion',
  RoomVersion: 'RoomVersion',
  ChargeAllocationsView: 'ChargeAllocationsView',
  ChargePayerAmountView: 'ChargePayerAmountView'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
